import * as React from 'react';
import Icons from '../icons';

export default class EmptyDiary extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="emptyDiaryWhiteBg" className="" />    
                <h2>No Diaries Found</h2>
                <p>
                    There are no matching results found
                </p>
            </div>
        );
    }
}